import {Link} from 'react-router-dom';
import './LegalText.scss';

const DataPrivacyText = () => {
    return (<div className="legal-text">
            <div className="legal-text-header">
                <h4>
                    Datenschutzerklärung und Cookie-Richtlinie
                </h4>
            </div>
            <p>
                Als Verantwortlicher im Sinn der
                Europäischen Datenschutz-Grundverordnung (&bdquo;<b>DSGVO</b>&ldquo;) und des
                Bundesdatenschutzgesetzes (&bdquo;<b>BDSG</b>&ldquo;) erhebt, verarbeitet
                und nutzt die Sportcast GmbH, <span>Kaltenbornweg
                    2, D-50679 Köln </span>(&bdquo;<b>Sportcast</b>&ldquo;)
                personenbezogene Daten, die bei dem Besuch und der Nutzung der
                Internetseite&nbsp;report.sportcast.de sowie deren jeweiligen
                Unterdomänen (insgesamt: &bdquo;<b>Portal</b>&ldquo;) erhoben und
                gespeichert werden, unter Beachtung der in der Bundesrepublik
                Deutschland geltenden datenschutzrechtlichen Bestimmungen,
                insbesondere der DSGVO und des BDSG. Diese Datenschutzerklärung und
                Cookie-Richtlinie (nachfolgend zusammenfassend &bdquo;<b>Erklärung</b>&ldquo;)
                erläutert, welche personenbezogenen Daten der Nutzer und Nutzerinnen
                des Portals (nachfolgend einheitlich bezeichnet als: &bdquo;<b>Nutzer</b>&ldquo;)
                erfasst und wie diese Daten verarbeitet werden.</p>
            <span className="header-span">
                1. Datenerhebung und -verarbeitung bei Zugriffen auf das Portal
            </span>
            <p>
                Bei jedem Zugriff eines Nutzers auf das
                Portal übermittelt der Internetbrowser des Nutzers aus technischen
                Gründen automatisch die folgenden Daten an den Webserver der
                Sportcast:
            </p>
            <ul>
                <li>IP-Adresse des anfragenden Endgeräts</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der aufgerufenen Seite</li>
                <li>Übertragene Datenmenge</li>
                <li>Zugriffsstatus (Datei übertragen, Datei nicht gefunden etc.)</li>
                <li>Erkennungsdaten des verwendeten Browser- und Betriebssystems des Endgeräts des Nutzers</li>
                <li>Name des Internetproviders des Nutzers</li>
                <li>Website, von der aus der Zugriff erfolgt</li>
                <li>Beantwortungszeit des Zugriffs</li>
            </ul>
            <p>
                Die Erhebung und Verarbeitung dieser
                Daten erfolgen zum Zweck der Ermöglichung der Nutzung des Portals
                (Verbindungsaufbau), der Systemsicherheit sowie der technischen
                Administration der Netzinfrastruktur. Ein Abgleich mit anderen
                Datenbeständen oder eine Weitergabe an Dritte, auch in Auszügen,
                findet nicht statt.
            </p>
            <p>
                Rechtsgrundlage der Verarbeitung ist
                Art. 6 Abs. 1 Satz 1 f) DSGVO. Das berechtigte Interesse der
                Sportcast besteht darin, ein sicheres und funktionierendes Portal
                zur Verfügung zu stellen.
            </p>

            <span className="header-span">
                    2. Datenerhebung und -verarbeitung im Rahmen der Registrierung und Nutzung des Portals
            </span>
            <p>
                Die Nutzung des Portals erfordert eine
                vorherige Registrierung einschließlich der Angabe personenbezogener
                Daten (Name, Kontaktdaten, etc.) durch den Nutzer und
                anschließend ein Login. Nach Login bleibt der Nutzer dabei bis zum Ablauf der Session,
                welche nach 8-stündiger Inaktivität eintritt, eingeloggt, soweit er sich nicht vorher aktiv ausloggt oder seinen Browserverlauf
                bzw.-cache löscht. Die Rechtsgrundlage der Verarbeitung ist jeweils Art. 6 Abs. 1 Satz 1 b) DSGVO.
            </p>

            <span className="header-span">
                    3. Datenerhebung und -verarbeitung im Rahmen der Kontrolle der Einhaltung der Bestimmungen der
                    Nutzungsbedingungen des Portals und Fehlerbehebung
            </span>
            <p>
                Die Sportcast behält sich vor, zur
                Kontrolle bzgl. der Einhaltung der Bestimmungen der <Link to="/terms-of-use" target="_blank"
                                                                          rel="noreferrer">Nutzungsbedingungen</Link> sowie zur
                etwaigen
                Fehlerbehebung die Nutzung des Portals zu protokollieren. Für diesen
                Fall werden die Verbindungsdaten für den Zugang zum Portal
                mit Angaben von Datum/Uhrzeit, Adresse des Nutzers und genutzte
                Inhalte und Seiten protokolliert. Die Protokolle werden neben der
                Verwendung zu Vertragszwecken nur zu Zwecken der
            </p>

            <ul>
                <li>Analyse und Korrektur technischer
                    Fehler
                </li>
                <li>
                    Gewährleistung der
                    Systemsicherheit
                </li>
                <li>
                    Optimierung des Nutzers
                </li>
                <li>
                    statistische Feststellung des
                    Gesamtnutzungsvolumens und
                </li>
                <li>
                    der Auswertung im Rahmen der
                    Missbrauchskontrolle nach Ziffer 7 der Nutzugsbedingungen des
                    Portals verwendet.
                </li>
            </ul>

            <p>
                Die Sportcast behält sich die
                stichprobenhafte Sichtung der Protokolle vor. Der Zugriff auf die
                Protokolle ist auf den Datenschutzbeauftragten der Sportcast
                und die mit der Systemadministration betrauten Personen begrenzt.
            </p>

            <p>
                Rechtsgrundlage der Verarbeitung ist
                Art. 6 Abs. 1 Satz 1 f) DSGVO. Die berechtigten Interessen der
                Sportcast liegen in der Auswertung dieser Protokolldaten zum Zweck
                der Optimierung und Sicherheit des Portals.
            </p>

            <span className="header-span">
            4. Feedback
            </span>
            <p>
                Die Sportcast gibt den Nutzern (z.B. über ein separates Microsoft Forms-Feedbackformular oder per E-Mail)
                die Möglichkeit, ein Feedback zu dem Portal und seinen Funktionen zu geben
                sowie um aufgetretene Fehler zu melden. Das Feedback und die weiteren Rückmeldungen verwendet die Sportcast dazu,
                das Portal und die angebotenen Funktionen zu verbessern.
            </p>
            <p>
                Nähere Informationen über die Datenverarbeitung durch Microsoft Forms finden sich <a
                href="https://support.microsoft.com/de-de/office/sicherheit-und-datenschutz-in-microsoft-forms-7e57f9ba-4aeb-4b1b-9e21-b75318532cd9"
                target="_blank" rel="noreferrer">hier.</a>
            </p>
            <p>
                Rechtsgrundlage der Verarbeitung ist die Einwilligung des Nutzers gemäß Art. 6 Abs. 1 Satz 1 a) DSGVO,
                welche der Nutzer jederzeit mit Wirkung für die Zukunft widerrufen kann.
            </p>

            <span className="header-span">
            5. Cookies
            </span>
            <p>
                Die Sportcast setzt auf dem Portal verschiedene Cookies ein. Cookies sind kleine Textdateien, die auf dem Endgerät des
                Nutzers abgelegt werden und es ermöglichen, dieses Endgerät wiederzuerkennen. Die Nutzer haben die Möglichkeit, ihren Browser so
                einzustellen,
                dass keine Cookies gesetzt werden können. Unter Umständen funktionieren in diesem Fall bestimmte Bereiche des Portals jedoch nicht.
            </p>

            <p>
                Die Sportcast setzt auf dem Portal die folgenden unbedingt erforderlichen Cookies ein:
            </p>

            <table className="cookie-table" cellPadding="7" cellSpacing="0">
                <thead>
                <tr>
                    <td width="60">
                        <b>Name</b>
                    </td>
                    <td width="99">
                        <b>Domain</b>
                    </td>
                    <td width="210">
                        <b>First Party / Third Party</b>
                    </td>
                    <td width="120">
                        <b>Lebensdauer</b>
                    </td>
                    <td width="280">
                        <b>Beschreibung</b>;
                    </td>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        Consent_Technical_Cookies
                    </td>
                    <td>
                        report.sportcast.de
                    </td>
                    <td>
                        First Party
                    </td>
                    <td>
                        1 Jahr
                    </td>
                    <td>
                        Vorhaltung des Status bzgl. der Kenntnisnahme des Cookie-Banners durch einen Nutzer und damit einhergehende Verhinderung der
                        erneuten Anzeige des Cookie-Banners
                    </td>
                </tr>
                <tr>
                    <td>
                        Session
                    </td>
                    <td>
                        report.sportcast.de
                    </td>
                    <td>
                        First Party
                    </td>
                    <td>
                        8 Stunden
                    </td>
                    <td>
                        Authentifizierung des Nutzers
                    </td>
                </tr>
                <tr>
                    <td>
                        SPCSSO
                    </td>
                    <td>
                        sportcast.de
                    </td>
                    <td>
                        First Party
                    </td>
                    <td>
                        6 Stunden
                    </td>
                    <td>
                        Authentifizierung des Nutzers
                    </td>
                </tr>
                </tbody>
            </table>
            <p>
                Unbedingt erforderliche Cookies sind zur Funktion des Portals erforderlich und können durch die Nutzer nicht deaktiviert werden.
                Rechtsgrundlage für die Verwendung solcher Cookies ist die Wahrung berechtigter Interessen der Sportcast gemäß Art. 6 Abs. 1 Satz 1 f)
                DSGVO.
                Die berechtigten Interessen der Sportcast liegen in dem sicheren und möglichst effizienten Betrieb des Portals.
            </p>
            <span className="header-span">
                6. Datenweitergabe an Dritte
            </span>
            <p> Die Sportcast gibt personenbezogene Daten außer den dargestellten Fällen nur dann an Dritte weiter, wenn sie hierzu berechtigt oder
                verpflichtet ist.
                Das ist insbesondere dann der Fall, wenn die Sportcast im Rahmen zwingender nationaler Rechtsvorschriften oder im Fall von Angriffen
                auf
                die Netzinfrastruktur zur Rechts- oder Strafverfolgung personenbezogene Daten an staatliche Einrichtungen und Behörden übermittelt.
                Rechtsgrundlage der Verarbeitung ist in diesem Fall Art. 6 Abs. 1 Satz 1 c) DSGVO in Verbindung mit § 24 Abs. 1 Nr. 1 BDSG.
            </p>

            <span className="header-span">
                7. Aufbewahrung und Löschung personenbezogener Daten
            </span>
            <p>
                Sämtliche gespeicherten personenbezogenen Daten und pseudonymisierten Nutzungsdaten werden - sobald sie für die Zwecke, für die sie
                erhoben wurden,
                nicht mehr benötigt werden oder der Nutzer dies verlangt - unmittelbar und unwiederbringlich gelöscht, sofern die Sportcast nicht
                aufgrund gesetzlicher Vorschriften
                zur Aufbewahrung verpflichtet oder berechtigt ist. Ist die Sportcast aufgrund gesetzlicher Vorschriften zur Aufbewahrung verpflichtet
                oder berechtigt,
                so werden die gespeicherten personenbezogenen Daten und pseudonymisierten Nutzungsdaten mit Ablauf der
                gesetzlich vorgeschriebenen Aufbewahrungsfristen unwiederbringlich gelöscht.
            </p>
            <span className="header-span">
                8. Sicherheit
            </span>
            <p>
                Die Sportcast setzt technische und organisatorische Sicherheitsmaßnahmen ein, um die personenbezogenen Daten der Nutzer
                gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen
                zu schützen. Die Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend angepasst.
                Dennoch weist die Sportcast die Nutzer darauf hin, dass eine vollständige Sicherheit
                bei Datenübermittlungen im Netz nie gewährleistet werden kann.
            </p>
            <span className="header-span">
                9. Links zu Websites anderer Anbieter
            </span>
            <p>
                Das Portal kann Links zu Websites anderer Anbieter enthalten. Diese Erklärung gilt ausschließlich für das Portal.
                Die Sportcast hat keinen Einfluss auf Inhalte anderer Anbieter und kontrolliert nicht, dass andere Anbieter
                die geltenden Datenschutzbestimmungen oder sonstigen rechtlichen Anforderungen einhalten. Sollte ein Nutzer
                die Sportcast auf rechtswidrige Inhalte auf verlinkten Seiten hinweisen,
                wird die Sportcast die Links umgehend von dem Portal entfernen.
            </p>
            <span className="header-span">
                10. Rechte des Nutzers
            </span>
            <p>
                Dem Nutzer stehen nach der DSGVO einige
                Rechte zu. Insbesondere hat der Nutzer
            </p>
            <ul>
                <li>
                    ein Auskunftsrecht bezüglich der über ihn gespeicherten personenbezogenen Daten (Art. 15 DSGVO);
                </li>
                <li>
                    ein Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO);
                </li>
                <li>
                    ein Recht auf Löschung der Daten unter den Voraussetzungen des Art. 17 DSGVO;
                </li>
                <li>
                    ein Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO);
                </li>
                <li>
                    ein Recht auf Datenübertragbarkeit nach Art. 20 DSGVO; und
                </li>
                <li>
                    ein Recht auf Widerspruch gegen die Verarbeitung, soweit diese zur Wahrung der berechtigten Interessen der Sportcast erfolgt (Art.
                    21 DSGVO).
                </li>
            </ul>
            <p>
                Der Nutzer kann seine Rechte durch eine E-Mail an <a
                href="mailto:registration.report@sportcast.de">registration.report@sportcast.de</a> oder über die eingangs
                aufgeführte Adresse per
                Brief geltend machen. Der Datenschutzbeauftragte der Sportcast ist
                unter <a href="mailto:datenschutz@sportcast.de">datenschutz@sportcast.de</a> erreichbar;
                unter dieser E-Mail-Adresse werden lediglich datenschutzbezogene Anfragen beantwortet.
            </p>
            <p>
                Weiterhin
                kann der Nutzer sich bei einer zuständigen Aufsichtsbehörde über
                die Datenverarbeitung beschweren. Für die Sportcast zuständig ist
                der Landesbeauftragte für Datenschutz und Informationsfreiheit
                Nordrhein-Westfalen, bei dem der Nutzer unter
                folgendem <a href="https://www.ldi.nrw.de/kontakt/ihre-beschwerde" target="_blank" rel="noreferrer">Link</a> Beschwerde einreichen
                kann.
            </p>
            <span className="header-span">
                    11. Wo kann der Nutzer die
                    relevanten Gesetzestexte finden?
            </span>
            <p>
                Die DSGVO kann der Nutzer unter
                folgendem <a href="https://eur-lex.europa.eu/legal-content/DE/TXT/?uri=celex%3A32016R0679" target="_blank"
                             rel="noreferrer">Link</a> abrufen, das BDSG
                und sonstige
                relevante deutsche Gesetzestexte wiederum unter folgendem <a href="https://www.gesetze-im-internet.de/bdsg_2018/"
                                                                             target="_blank" rel="noreferrer">Link</a>.
            </p>
            <span className="header-span">
                    12. Einbeziehung, Gültigkeit und
                    Aktualität der Erklärung
            </span>
            <p>
                Im Rahmen der Nutzung des Portals gelten für den Nutzer die in dieser Erklärung beschriebenen Regeln zur Erhebung, Verarbeitung und
                Nutzung seiner Daten. Die Erklärung ist aktuell und datiert vom 1. Juli 2023. Die Sportcast behält sich vor, die Erklärung bei Bedarf,
                insbesondere zur Anpassung an eine Weiterentwicklung des Portals oder Implementierung neuer Technologien, jederzeit mit Wirkung für
                die Zukunft zu ändern. Der Nutzer kann die aktuell gültige Erklärung jederzeit auf dem Portal unter dem Menüpunkt
                &bdquo;Datenschutzerklärung und Cookie-Richtlinie&ldquo; im Footer einsehen.
            </p>

            <div className="text-end mt-4">Stand: 01.07.2023</div>
        </div>
    );
};
export default DataPrivacyText;
